import React from "react";
import { Star } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

/**
 * Toggle star for bookmarking a message. Registered users only —
 * caller should hide it entirely for guests.
 */
export default function BookmarkBtn({ messageId, sourceType, sourceId, bookmarked, onChange, size = "w-4 h-4" }) {
  const toggle = async () => {
    try {
      if (bookmarked) {
        await api.delete(`/bookmarks/${encodeURIComponent(messageId)}`);
        onChange && onChange(false);
      } else {
        await api.post("/bookmarks", { message_id: messageId, source_type: sourceType, source_id: sourceId });
        onChange && onChange(true);
        toast.success("Saved");
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't update bookmark.");
    }
  };
  return (
    <button
      type="button"
      onClick={toggle}
      className={bookmarked ? "text-acid" : "text-white/40 hover:text-acid"}
      title={bookmarked ? "Remove bookmark" : "Save this message"}
      data-testid={`bookmark-btn-${messageId}`}
    >
      <Star className={`${size} ${bookmarked ? "fill-current" : ""}`} />
    </button>
  );
}
